import { createHook } from 'react-sweet-state';

import { MultiSelectMode, Store } from '../store';

export const useIsMultiSelectActive = createHook(Store, {
	selector: (state) => state.multiSelectMode === MultiSelectMode.ACTIVE,
});
